// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"807aeb6e","76":"524530c5","147":"ae6dcd8c","561":"ec865d7f","565":"ee703160"}[chunkId] + ".css";
};